enum TargetNodes {
  All = 'All nodes',
  Selected = 'Selected nodes',
  AllResult = 'All nodes in query result',
  SelectedResult = 'Selected nodes in query result',
}

export default TargetNodes